module.exports = __webpack_public_path__ + "media/images/weather/441_day-ac0f236470f94f126c65040434000bb6.png";